export class MapReplyOfficesRuntime extends HTMLElement {
    private mapElement: HTMLElement;
    private regionSelector: HTMLElement;
    private countrySelector: HTMLElement;
    private backToCountries: HTMLElement;
    private regionSelected: string = 'all';
    private countrySelected: string;

    constructor() {
        super();
        this.accordionClick = this.accordionClick.bind(this);
        this.regionFilterClick = this.regionFilterClick.bind(this);
        this.countryFilterClick = this.countryFilterClick.bind(this);
    }

    public connectedCallback(): void {
        this.regionSelector = this.querySelector('.region-filters');
        this.mapElement = this.parentElement.querySelector('.map-offices-container');
        if (this.regionSelector) {
            this.regionSelector.addEventListener('click', this.regionFilterClick);
        }

        this.countrySelector = this.querySelector('.country-filters');
        if (this.countrySelector) {
            this.countrySelector.addEventListener('click', this.countryFilterClick);
        }

        this.backToCountries = this.querySelector('.back-to-countries');
        if (this.backToCountries) {
            this.backToCountries.addEventListener('click', this.countryFilterClick);
        }

        this.addEventListener('click', this.accordionClick); // delegated
    }

    public disconnectedCallback(): void {
        if (this.regionSelector) {
            this.regionSelector.removeEventListener('click', this.regionFilterClick);
        }

        if (this.countrySelector) {
            this.countrySelector.removeEventListener('click', this.countryFilterClick);
        }

        this.removeEventListener('click', this.accordionClick);

        this.mapElement.classList.remove("hidden")
    }

    private regionFilterClick(event: Event): void {
        const element: HTMLElement = event.target as HTMLElement;
        this.regionSelected = element.dataset?.region;
        this.countrySelected = undefined;
        this.markActive(element);
        this.selectionChanged();
    }

    private countryFilterClick(event: Event): void {
        const element: HTMLElement = event.target as HTMLElement;
        // this.regionSelected = element.dataset?.region || this.regionSelected;
        this.countrySelected = element.dataset?.country;
        this.markActive(element);
        this.selectionChanged();
    }

    private selectionChanged() {
        const regionSelected = this.regionSelected;
        for (const el of this.querySelectorAll<HTMLElement>('.country-filter-selector')) {
            el.classList.toggle('hidden', regionSelected && regionSelected !== 'all' && el.dataset.region !== regionSelected);
        }
        if (this.countrySelected) {
            this.querySelector(".region-filters").classList.add('hidden');
            for (const el of this.querySelectorAll(".country-filter-selector")) {
                el.classList.add('hidden');
            }
            for (const el of this.querySelectorAll('.country-offices')) {
                el.classList.add('hidden');
            }
            this.querySelector(`.country-offices[data-country='${this.countrySelected}']`).classList.remove('hidden');
            const region = this.querySelector(`.region-filter-selector[data-region='${regionSelected}']`);
            (this.backToCountries.querySelector('.label') as HTMLElement).textContent = region?.textContent ?? 'All regions';
            this.backToCountries.classList.remove('hidden');
            this.querySelector('.heading').classList.add('hidden');
        } else {
            this.querySelector(".region-filters").classList.remove('hidden');
            for (const el of this.querySelectorAll(".country-offices")) {
                el.classList.add('hidden');
            }
            this.backToCountries.classList.add('hidden');
            this.querySelector('.heading').classList.remove('hidden');
        }
    }

    private accordionClick(event: Event): void {
        const targetElement = (event.target as Element).closest('.accordion-heading-button');
        if (targetElement && this.contains(targetElement)) {
            const cityOfficeContainer: HTMLElement = targetElement.closest('.city-office-container');
            const accordionContent: Element = targetElement.nextElementSibling;
            if (cityOfficeContainer) {
                for (const el of this.querySelectorAll('.city-office-container')) {
                    if (el !== cityOfficeContainer) {
                        el.classList.remove('visible');
                        const elChildren = el.children;
                        if (elChildren[0]) {
                            elChildren[0].ariaExpanded = 'false';
                        }
                        if (elChildren[1]) {
                            elChildren[1].ariaHidden = 'true';
                        }
                    }
                }
                cityOfficeContainer.classList.toggle('visible');
                targetElement.ariaExpanded = targetElement.ariaExpanded === 'true' ? 'false' : 'true';
                if (accordionContent) {
                    accordionContent.ariaHidden = accordionContent.ariaHidden === 'true' ? 'false' : 'true';
                }
            }

        }
    }

    private markActive(element: HTMLElement) {
        const isBack = element.dataset?.back;

        if (element.classList.contains('region-filter-selector')) {
            for (const el of this.querySelectorAll('.region-filter-selector')) {
                el.classList.remove('active');
            }
        } else if (isBack) {
            for (const el of this.querySelectorAll('.region-filter-selector')) {
                el.classList.remove('active');
            }

            for (const el of this.querySelectorAll<HTMLElement>('.region-filter-selector')) {
                if (el.dataset?.region === this.regionSelected) {
                    el.classList.add('active');
                }
            }
        }

        element.classList.add('active');
    }
}
